import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoginService } from '../services/login/login.service';
import { ApiService } from '../services/api/api.service';

@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {
  private loginService = inject(LoginService);


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (
              err.status === 401 &&
              request.url.includes(ApiService.API_URL) &&
              !request.url.includes(`${ApiService.API_URL}/authenticate`)
            ) {
              this.loginService.logout();
            }
          }
        }
      )
    );
  }
}
